    <i *ngIf="tooltip" ngbPopover="{{tooltip}}" triggers="mouseenter:mouseleave" class="fa fa-question-circle-o ms-2"></i>
